import Link from 'next/link';

export default function TermsOfUse() {
  const year = new Date().getFullYear();
  return (
    <div className="max-w-screen-md mx-auto mt-20 mb-14 font-brand text-gray-700">
      <div>
        <h1 className=" text-4xl">Terms of Use</h1>
        <h3 className=" text-xl">Effective Date: January 1, 2020</h3>
      </div>
      <br />
      <div className="prose text-gray-800">
        <h4>Introduction</h4>
        <p>
          THESE TERMS OF USE GOVERN YOUR USE OF THE CONTRACTORBONDS WEBSITE
          (“COMPANY”, “WE”, “OUR”, OR “US”) LOCATED AT{' '}
          <Link href="/" className="underline">
            ContractorBonds.com
          </Link>{' '}
          OR OTHER WEBSITES CONTROLLED BY COMPANY AND ITS AFFILIATES AS WELL AS
          ANY DOCUMENTS EXPRESSLY INCORPORATED BY REFERENCE AND ANY RULES AND
          POLICIES PUBLISHED ON THIS WEBSITE (THE “WEBSITE”).
        </p>
        <p>
          BY ACCESSING THIS WEBSITE, YOU AGREE TO THE TERMS OF USE, AND ANY
          REVISIONS, AND MODIFICATIONS. ALL CHANGES ARE EFFECTIVE IMMEDIATELY
          UPON POSTING, AND APPLY TO ALL ACCESS TO AND USE OF THE WEBSITE
          THEREAFTER. ANY CHANGES WILL NOT AFFECT ANY DISPUTES ARISING PRIOR TO
          THE EFFECTIVE DATE OF THE CHANGE. We may send you notices with respect
          to the Service in various mediums, including by email address, postal
          mail, and/or by posting on the WEBSITE.
        </p>
        <p>
          ARBITRATION NOTICE: EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN
          THE “ARBITRATION AND CLASS ACTION WAIVER” SECTION BELOW, AND IF YOU DO
          NOT OPT-OUT AS SET FORTH IN THAT SAME SECTION, YOU AGREE THAT DISPUTES
          BETWEEN YOU AND COMPANY OR ITS AFFILIATES WILL BE RESOLVED BY BINDING,
          INDIVIDUAL ARBITRATION, AND YOU WAIVE YOUR RIGHT TO BRING OR RESOLVE
          ANY DISPUTE AS, OR PARTICIPATE IN, A CLASS, CONSOLIDATED,
          REPRESENTATIVE, COLLECTIVE, OR PRIVATE ATTORNEY GENERAL ACTION OR
          ARBITRATION.
        </p>
        <br /> <br />
        <h4>ACCESS TO THIS WEBSITE</h4>
        <p>
          To access the Website or some of its resources, you may be asked to
          provide certain personal details or other information. It is a
          condition of your use of the Website that all the information you
          provide on the Website is correct, current, and complete.
        </p>
        <p>
          In addition, certain other services of the Website, such as applying
          for coverage, may be governed by additional or different terms and
          conditions. You should carefully review those terms and conditions as
          they are presented to you.
        </p>
        <p>
          We reserve the right to withdraw, amend, disable or suspend this
          Website, and any service or material we provide on the Website, in our
          sole discretion with or without notice. We will not be liable if for
          any reason all or any part of the Website is unavailable at any time
          or for any period. From time to time, we may restrict access to some
          parts of the Website, or the entire Website, to users, including
          registered users.
        </p>
        <p>
          We have the right to disable any user name, password or other
          identifier, whether chosen by you or provided by us, at any time in
          our sole discretion for any or no reason, including if, in our
          opinion, you have violated any provision of these Terms of Use.
        </p>
        <br /> <h4>PRIVACY</h4>
        <p>
          Your use of the Service is also subject to our Privacy Policy that is
          available online{' '}
          <a href="https://contractorbonds.com/privacy-policy/">here</a>{' '}
          (“Privacy Policy”) and is incorporated into and made a part of these
          Terms of Use. The Privacy Policy is subject to change, and you are
          encouraged to review the Privacy Policy whenever you supply the
          Website with any information.
        </p>
        <br /> <h4>RESTRICTIONS ON USE</h4>
        <p>
          You may use this Website only for your internal, non-commercial
          purposes. You agree not to use this Website in any way that violates
          any applicable federal, state, local or international law or
          regulation. You further agree to maintain and update your registration
          data as needed to keep it accurate, current and complete. You may not
          use this Website or any of the content, defined below, contained on it
          for any other purpose, including any unpermitted commercial purpose,
          unless we provide our prior written consent to such use.
        </p>
        <p>
          Uses requiring our prior written consent include the following,
          without limitation:
        </p>
        <ol>
          <li>co-branding this Website </li>
          <li>framing this Website </li>
          <li>
            using any robots, scrapers, spiders, data mining tools, or any
            similar device, tool, software, or process 
          </li>
          <li>hyper-linking to specific product or coverage information or </li>
          <li>reselling or remarketing the content, as defined below.</li>
        </ol>{' '}
        <br />
        <p>
          "Co-branding" means displaying a name, logo, trademark or other means
          of attribution or identification of any party in a manner reasonably
          likely to give a user the impression that the other party has the
          right to display, publish or distribute this Website or its content.
          You will cooperate fully with Company and its affiliates in causing
          any unpermitted or unauthorized activity of yours or a third party
          authorized by you to cease immediately. To the extent that such
          unpermitted or unauthorized use continues after notice from Company or
          its affiliates, you agree to pay or reimburse us for any and all costs
          associated with ending or terminating such use.
        </p>
        <p>
          You agree not to impersonate or attempt to impersonate the Company, a
          Company employee, another user or any other person or entity
          (including, without limitation, by using e-mail addresses associated
          with any of the foregoing).
        </p>
        <br /> <h4>PROHIBITED ACTIONS</h4>
        <p>Additionally, you agree not to:</p>
        <ul>
          <li>
            decompile, reverse engineer, disassemble, modify, reduce the Website
            to human perceivable form or create derivative works based upon the
            Website or any part thereof
          </li>
          <li>disable any licensing or control features of the Website</li>
          <li>
            “frame” the Website or any portion thereof or otherwise cause the
            Website or its contents to appear to be provided by anyone except
            Company and its affiliates
          </li>
          <li>
            merge the Website or materials with another program or create
            derivative works based on the Website or materials
          </li>
          <li>
            remove, obscure, or alter any notice of the copyright or other
            proprietary legends on the Website or materials
          </li>
          <li>
            sublicense, assign, translate, rent, lease, lend, resell for profit,
            distribute or otherwise assign or transfer the materials or access
            to the Website to others
          </li>
          <li>
            use the Website by means of any automated program, expert system,
            electronic agent or “bot,” and shall not give any person or entity
            access to the Website
          </li>
          <li>
            utilize any “scraping,” copying, republishing, licensing, or selling
            the data or information on the Website.
          </li>
        </ul>{' '}
        <br />
        <br /> <h4>PROPRIETARY INFORMATION</h4>
        <p>
          The material and content accessible from this Website and any other
          website Company or its affiliates owns, operates, licenses or controls
          (the “content”) is the proprietary information of Company or its
          affiliates or the party that provided the Content to us, and Company
          and its affiliates or such party retains all right, title and interest
          in the content. Accordingly, the Content may not be copied,
          distributed, republished, uploaded, posted, rented, leased,
          distributed, modified or transmitted in any way without the prior
          written consent of Company and its affiliates, except that you may
          print out a copy of the content solely for your own personal use. In
          doing so, you may not remove or alter, or cause the removal or
          alteration of, any copyright, trademark, trade name, service mark or
          any other proprietary notice or legend appearing on any of the
          content. Modification or use of the content, except as expressly
          provided herein, may violate Company’s and its affiliates’
          intellectual property rights or a third party’s rights. Neither title
          nor intellectual property rights in the content are transferred or
          licensed to you by these Terms or your access of this Website.
        </p>
        <br /> <h4>TRADE SECRETS</h4>
        <p>
          Certain information provided to you by Company or its affiliates
          through non-public portions of the Website may be confidential or
          trade secret information. You may use or disclose such information
          only to the extent necessary for the purposes it was disclosed to you.
          You may not use the Website to circumvent the terms of any referral
          agreement or in any other manner that is not consistent with the
          business purpose of the Website. When reasonable, you must return or
          destroy such information when you have fulfilled such purpose.
        </p>
        <br /> <h4>HYPER-LINKS</h4>
        <p>
          We may hyper-link from the Website to other websites that are not
          maintained by, or related to, Company or its affiliates. Such
          hyper-links are provided as a service to you, and the other websites
          may not be officially sponsored by or affiliated with this Website or
          Company and its affiliates. Such other websites are solely responsible
          for their content. We are under no obligation to maintain any link on
          this Website and may remove any such link at any time in its sole
          discretion for any reason whatsoever. Access hyper-links and third
          party websites at your own risk.
        </p>
        <p>
          COMPANY AND ITS AFFILIATES MAKE NO REPRESENTATIONS OR WARRANTIES ABOUT
          THE CONTENT OF THIRD-PARTY WEBSITES. SUCH HYPER-LINKS ARE PROVIDED TO
          YOU “AS-IS” “WHERE IS,” AND WE SPECIFICALLY DISCLAIM ANY WARRANTIES
          WITH REGARD TO COMPLETENESS OR ACCURACY OF THESE HYPER-LINKS OR THE
          WEBSITES THAT ARE HYPER-LINKED TO THIS WEBSITE. THE INCLUSION OF ANY
          HYPER-LINK TO A THIRD-PARTY WEBSITE DOES NOT NECESSARILY IMPLY
          ENDORSEMENT BY OR AFFILIATION WITH COMPANY OR ITS AFFILIATES OF THAT
          WEBSITE.
        </p>
        <br /> <h4>SOCIAL MEDIA FEATURES</h4>
        <p className="font-bold mb-2">
          This Website may provide certain social media features that enable you
          to:
        </p>
        <ul>
          <li>
            link from your own or certain third-party websites to certain
            content on this Website.
          </li>
          <li>
            send e-mails or other communications with certain content, or links
            to certain content, on this Website.
          </li>
          <li>
            cause limited portions of content on this Website to be displayed or
            appear to be displayed on your own or certain third-party websites.
          </li>
        </ul>{' '}
        <br />
        <p>
          You may use these features solely as they are provided by us and
          solely with respect to the content they are displayed with and
          otherwise in accordance with any additional terms and conditions we
          provide with respect to such features. Subject to the foregoing, you
          must not:
        </p>
        <ul>
          <li>establish a link from any website that is not owned by you.</li>
          <li>
            cause the Website or portions of it to be displayed, or appear to be
            displayed by, for example, framing, deep linking or in-line linking,
            on any other site.
          </li>
          <li>link to any part of the Website other than the homepage.</li>
          <li>
            otherwise take any action with respect to the materials on this
            Website that is inconsistent with any other provision of these Terms
            of Use.
          </li>
        </ul>{' '}
        <br />
        <p>
          You agree to cooperate with us in causing any unauthorized framing or
          linking immediately to cease. We reserve the right to withdraw linking
          permission without notice. We may disable all or any social media
          features and any links at any time without notice in our discretion.
        </p>
        <br /> <h4>SUBMISSIONS</h4>
        <p>
          You hereby grant to Company and its affiliates the royalty-free,
          perpetual, irrevocable, worldwide, non-exclusive right and license to
          use, reproduce, modify, adapt, publish, translate, create derivative
          works from, distribute, perform and display all stories, anecdotes,
          “Similes,” content, remarks, suggestions, ideas, graphics, inventions,
          methods, process, algorithms or other information communicated to us
          through this Website (collectively, the “Submission”), and to
          incorporate any Submission into other works in any form, media or
          technology now known or later developed. We may use any submission in
          our business (including without limitation, for products or
          advertising) without incurring any liability for royalties or any
          other additional consideration of any kind, and will not incur any
          liability as a result of any similarities to the submission that may
          appear in our future operations. By providing a Submission, you
          warrant that you have the right to provide the Submission and that all
          moral rights in the Submission have been waived.
        </p>
        <br /> <h4>DISCLAIMER</h4>
        <p>
          COMPANY AND ITS AFFILIATES CANNOT AND DOES NOT GUARANTEE OR WARRANT
          THAT ANY FILES AVAILABLE FOR DOWNLOADING FROM THE INTERNET ARE FREE OF
          VIRUSES, WORMS, TROJAN HORSES OR OTHER CODE THAT MAY HAVE
          CONTAMINATING OR DESTRUCTIVE PROPERTIES. You are responsible for
          implementing sufficient procedures and checkpoints to satisfy your
          particular requirements for security, for accuracy of data input and
          output, and for maintaining a means external to this Website for
          reconstructing lost data. WE DO NOT ASSUME ANY RESPONSIBILITY OR RISK
          FOR YOUR USE OF THE INTERNET OR THE WEBSITE.
        </p>
        <p>
          USE THIS WEBSITE AT YOUR OWN RISK. EXCEPT AS MAY BE EXPRESSLY STATED
          IN OTHER APPLICABLE TERMS AND CONDITIONS OR SIMILAR AGREEMENT, THE
          CONTENT IS PROVIDED “AS IS” AND "AS AVAILABLE" AND WITHOUT WARRANTIES
          OF ANY KIND, EITHER EXPRESSED OR IMPLIED. WE DISCLAIM ALL WARRANTIES
          INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, TITLE OR NON-INFRINGEMENT. WE DO NOT WARRANT THAT
          ANY FUNCTIONS OR CONTENT CONTAINED IN THIS WEBSITE WILL BE
          UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT
          THIS WEBSITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES
          OR OTHER HARMFUL COMPONENTS. WE DO NOT WARRANT OR MAKE ANY
          REPRESENTATION REGARDING USE OF THE CONTENT OR RESULTS THEREOF IN
          TERMS OF ACCURACY, RELIABILITY OR OTHERWISE EXCEPT FOR THE PERSON
          AND/OR FOR THE USE INTENDED. THE CONTENT MAY INCLUDE TECHNICAL
          INACCURACIES OR TYPOGRAPHICAL ERRORS, AND WE MAY MAKE CHANGES OR
          IMPROVEMENTS AT ANY TIME. YOU, AND NOT COMPANY AND ITS AFFILIATES,
          ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR OR
          CORRECTION IN THE EVENT OF ANY LOSS OR DAMAGE ARISING FROM THE USE OF
          THIS WEBSITE OR THE CONTENT. WE MAKE NO WARRANTIES THAT YOUR USE OF
          THE CONTENT WILL NOT INFRINGE THE RIGHTS OF OTHERS AND ASSUME NO
          LIABILITY OR RESPONSIBILITY FOR ERRORS OR OMISSIONS IN SUCH CONTENT.
        </p>
        <p>
          BY ACCESSING THIS WEBSITE, YOU UNDERSTAND THAT YOU MAY BE WAIVING
          RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR
          UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE THAT
          YOU HAVE READ AND UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE BENEFITS
          OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, AND ANY SIMILAR LAW
          OF ANY STATE OR TERRITORY, WHICH PROVIDES AS FOLLOWS: "A GENERAL
          RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR
          SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE
          RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED
          HIS OR HER SETTLEMENT WITH THE DEBTOR."
        </p>
        <br /> <h4>RELIANCE</h4>
        <p>
          The descriptions of products and services contained on this Website
          are intended to provide a reference guide to the types of products and
          services offered by Company and its affiliates and are not intended to
          be relied upon by clients or business partners. Some products and
          services referenced on this Website may not be available in all areas.
          Please contact us directly if you wish to obtain specific information
          concerning the products and services referenced on this Website. All
          of the information in this Website, whether historical in nature or
          forward-looking, speaks only as of the date the information was posted
          on this Website, and we do not undertake any obligation to update such
          information or to remove such information from this Website, if it is
          not or is no longer accurate or complete.
        </p>
        <br /> <h4>LIMITATION ON LIABILITY</h4>
        <p>
          TO THE EXTENT PERMITTED BY LAW OR REGULATION, COMPANY AND ITS
          AFFILIATES, ITS SUBSIDIARIES, LICENSORS, SERVICE PROVIDERS, CONTENT
          PROVIDERS, EMPLOYEES, AGENTS, OFFICERS AND DIRECTORS WILL NOT BE
          LIABLE FOR ANY INCIDENTAL, DIRECT, INDIRECT, PUNITIVE, ACTUAL,
          CONSEQUENTIAL, SPECIAL, EXEMPLARY OR OTHER DAMAGES, INCLUDING LOSS OF
          REVENUE OR INCOME, PAIN AND SUFFERING, EMOTIONAL DISTRESS, OR SIMILAR
          DAMAGES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES THAT
          RELATES IN ANY WAY TO THE USE OF OUR WEBSITE OR WHICH MAY ARISE OUT OF
          ANY PERSON'S ACCESS OR INABILITY TO ACCESS THIS WEBSITE OR RELIANCE ON
          THE INFORMATION CONTAINED ON THIS WEBSITE. TO THE EXTENT PERMITTED BY
          LAW, IN NO EVENT WILL THE COLLECTIVE LIABILITY OF COMPANY AND ITS
          AFFILIATES AND ITS SUBSIDIARIES, LICENSORS, SERVICE PROVIDERS, CONTENT
          PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, AND DIRECTORS TO ANY PARTY
          (REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT, OR
          OTHERWISE) EXCEED THE GREATER OF $100 OR THE AMOUNT YOU PAID TO
          COMPANY OR ITS AFFILIATES FOR THE APPLICABLE CONTENT OR SERVICE OUT OF
          WHICH LIABILITY AROSE. BECAUSE SOME STATES OR JURISDICTIONS DO NOT
          ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY FOR CONSEQUENTIAL
          OR INCIDENTAL DAMAGES, IN SUCH STATES OR JURISDICTIONS, COMPANY’S
          LIABILITY SHALL BE LIMITED TO THE EXTENT PERMITTED BY LAW.
        </p>
        <br /> <h4>INDEMNIFICATION</h4>
        <p>
          You agree to defend, indemnify, and hold harmless Company and its
          affiliates, its subsidiaries, licensors, content providers, service
          providers, employees, agents, officers, directors and contractors (the
          “Indemnified Parties”) from any breach of these Terms of Use by you,
          including any use of the content other than as expressly authorized
          herein, and any claim that your submission violates a third party’s
          intellectual property or other rights, including the rights of
          publicity and privacy, or defames a third party. You agree that the
          Indemnified Parties will have no liability in connection with any such
          breach or unauthorized use, and you agree to indemnify any and all
          resulting loss, damages, judgments, awards, costs, expenses and
          attorneys’ fees of the Indemnified Parties in connection therewith.
          You will also indemnify and hold the Indemnified Parties harmless from
          and against any claims brought by third parties arising out of your
          use of the content and this Website.
        </p>
        <br /> <h4>TRADEMARKS</h4>
        <p>
          Trademarks, service marks and logos appearing in this Website
          (collectively, the “marks”) are the property of Company and its
          affiliates or the party that provided us the marks, and we or such
          party retain all rights with respect to such respective marks. No
          rights in any marks are granted to you by this agreement or your
          access of this Website. The Company’s name and logo may not be used in
          any way, including in advertising or publicity pertaining to
          distribution of materials on this Website, without prior written
          permission. You are not authorized to use our logo as a hyperlink to
          this Website unless you obtain our written permission in advance,
          although we permit you to use certain designated features of the
          Website to use our logo as a hyperlink for designated purposes. You
          may link to our homepage, provided you do so in a way that is fair and
          legal and does not damage our reputation or take advantage of it, but
          you must not establish a link in such a way as to suggest any form of
          association, approval or endorsement on our part without our express
          written consent.
        </p>
        <br /> <h4>COPYRIGHT</h4>
        <p>
          While the Company provides the information on this Website to anyone,
          we retain copyright on all p and graphic images. As such, one copy of
          the contents of this Website may be viewed, copied and downloaded for
          your own personal non-commercial use, provided that this Legal
          Disclaimer and Notice of Copyright appear in all copies. The contents
          of this Website may not be modified or used in any manner other than
          as expressly permitted by the immediately preceding sentence,
          including without limitation, utilization by reference or the
          establishment of a link, without the prior written consent of Company
          and its affiliates.
        </p>
        <p>
          Except as provided below, none of the materials may be copied,
          distributed, displayed, downloaded, or transmitted in any form or by
          any means without the prior written permission of Company and its
          affiliates or the copyright owner. Unauthorized use of any materials
          contained on this Website may violate copyright laws, trademark laws,
          the laws of privacy and publicity, and/or other regulations and
          statutes. If you believe that any of the materials infringe on any of
          your intellectual property rights, please contact us immediately at
          the address provided below. Except as expressly provided herein,
          Company and its affiliates and the third parties reserve all rights
          with respect to the Materials, and may pursue all legally available
          options under both civil and criminal laws (and may cooperate with law
          enforcement agencies) in the event of any violations, including but
          not limited to the right to terminate accounts of any user who has
          infringed a third party’s copyright three times. Pursuant to Title 17,
          United States Code, Section 512(c)(2), notifications of claimed
          copyright infringement should be sent to the Designated Agent. ALL
          INQUIRIES NOT RELEVANT TO THE FOLLOWING PROCEDURE WILL NOT RECEIVE A
          RESPONSE. Click{' '}
          <Link href="/infringement-notice" className="underline">
            here
          </Link>{' '}
          for link to separate Infringement Notice.
        </p>
        <br /> <h4>INFORMATION YOU PROVIDE</h4>
        <p>
          You may not post, send, submit, publish or transmit in connection with
          the Website any material that:
        </p>
        <ul>
          <li>
            you do not have the right to post, send, submit, publish or
            transmit, including any proprietary material of a third party;
          </li>
          <li>
            advocates illegal activity or discusses an intent to commit an
            illegal act;
          </li>
          <li>is vulgar, obscene, pornographic or indecent;</li>
          <li>does not pertain directly to the Website;</li>
          <li>
            threatens or abuses others; or libels, defames, invades privacy or
            stalks; or is racist, harassing, threatening or offensive;
          </li>
          <li>
            seeks to exploit or harm minors or older adults by exposing them to
            inappropriate content, asking for personally identifiable details or
            otherwise;
          </li>
          <li>
            infringes any intellectual property right or other right of any
            entity or person, including violating anyone’s copyrights or
            trademarks, or their rights of privacy or publicity;
          </li>
          <li>violates any law or may be considered to violate any law;</li>
          <li>
            impersonates or misrepresents your connection to any other entity or
            person, or otherwise manipulates headers or identifiers to disguise
            the origin of the content;
          </li>
          <li>
            advertises any commercial endeavor (e.g., products or services) or
            otherwise engages in any commercial activity (e.g., conducting
            raffles or contests, displaying sponsorship banners or soliciting
            goods or services, or any combination thereof) except as may be
            specifically authorized on this Website;
          </li>
          <li>solicits funds, advertisers or sponsors;</li>
          <li>
            includes programs that contain viruses, worms, Trojan horses or any
            other computer code, files or programs designed to interrupt,
            destroy or limit the functionality of any computer software,
            hardware or telecommunications or any combination thereof;
          </li>
          <li>amounts to a "pyramid" or similar scheme;</li>
          <li>
            disobeys any policy or regulations established from time to time
            regarding use of this Website or any networks connected to this
            Website; or
          </li>
          <li>
            contains hyper-links to other websites that contain content that
            falls within any description set forth above.
          </li>
        </ul>{' '}
        <br />
        <p>
          We reserve the right to monitor use of this Website in order to
          determine compliance with these Terms of Use, and reserve the right to
          remove or refuse any information for any reason. Notwithstanding these
          rights, you remain responsible solely for the content of your
          Submissions. YOU ACKNOWLEDGE AND AGREE THAT NEITHER COMPANY AND ITS
          AFFILIATES NOR ANY THIRD PARTY THAT PROVIDES CONTENT TO US WILL ASSUME
          OR HAVE ANY LIABILITY FOR ANY ACTION OR INACTION BY US OR SUCH THIRD
          PARTY WITH RESPECT TO ANY SUBMISSION OF YOURS. Except as expressly
          provided herein, Company and its affiliates and the third parties
          reserve all rights with respect to the Website, and may pursue all
          legally available options under both civil and criminal laws (and may
          cooperate with law enforcement agencies) in the event of any
          violations.
        </p>
        <br /> <h4>ARBITRATION AND CLASS ACTION WAIVER</h4>
        <p>
          Excluding claims for injunctive or other equitable relief, for claims
          related to the Website, including any goods or services purchased
          through the Website, any dispute or controversy arising out of or
          relating to this Agreement, including without limitation, any and all
          disputes, claims (whether in tort, contract, statutory or otherwise)
          or disagreements concerning the existence, breach, interpretation,
          application or termination of this Agreement shall be resolved by
          final and binding arbitration pursuant to the Federal Arbitration Act
          and in accordance with the JAMS Inc. Comprehensive Arbitration Rules &
          Procedures then in effect. There shall be no right or authority for
          any claims to be arbitrated on a class action basis. The arbitration
          shall take place in Missouri or at the option of the party seeking
          relief, by telephone, online, or via written submissions alone, and be
          administered by JAMS. The arbitral tribunal (“Tribunal”) shall be
          composed of one arbitrator, who shall be independent and impartial. If
          the parties fail to agree on the arbitrator within twenty (20)
          calendar days after the initiation of an arbitration hereunder, JAMS
          shall appoint the arbitrator. The arbitration shall be conducted in
          the English language. The decision of the arbitrator will be final and
          binding on the parties. Judgment on any award(s) rendered by the
          arbitrator may be entered in any court having jurisdiction thereof.
          The arbitrator shall have the authority to determine arbitrability of
          any disputes arising out of or relating to this Agreement. Nothing in
          this Section shall prevent either party from seeking immediate
          injunctive relief from any court of competent jurisdiction, and any
          such request shall not be deemed incompatible with the agreement to
          arbitrate or a waiver of the right to arbitrate. The parties undertake
          to keep confidential all awards in their arbitration, together with
          all confidential information, all materials in the proceedings created
          for the purpose of the arbitration and all other documents produced by
          the other party in the proceedings and not otherwise in the public
          domain, save and to the extent that disclosure may be required of a
          party by legal duty, to protect or pursue a legal right or to enforce
          or challenge an award in legal proceedings before a court or other
          judicial authority. The arbitrator shall award all fees and expenses,
          including reasonable attorney’s fees, to the prevailing party. Any
          judgment rendered by the arbitrator may be entered in any court of
          competent jurisdiction.
        </p>
        <p>
          Members may choose to opt out of the agreement to arbitrate by mailing
          a written opt-out notice (“Notice”) to Company. The Notice must be
          postmarked no later than thirty (30) days after the date you accept
          these Terms of Use for the first time. The Notice must be mailed to:
          3514 Interstate 70 Dr. SE, Columbia, Missouri 65201. This procedure is
          the only mechanism by which you can opt out of the agreement to
          arbitrate. Opting out of the agreement to arbitrate has no effect on
          any other parts of this Agreement, or any previous or future
          arbitration agreements that you have entered into with Company or its
          affiliates.
        </p>
        <br /> <h4>GOVERNING LAW</h4>
        <p>
          These Terms of Use are governed and interpreted by the laws of
          Missouri, United States of America, notwithstanding any principles of
          conflicts of law. We make no representation that materials on this
          Website are appropriate or available for use in other locations. Those
          who choose to access this Website from other locations do so on their
          own initiative and are responsible for compliance with applicable
          local laws.
        </p>
        <p>
          If you are a consumer, the provisions in these Terms are intended to
          be only as broad and inclusive as is permitted by the laws of your
          State of residence. If you are a New Jersey consumer, the terms of
          “Disclaimer” and “Limitation of Liability” sections above do not limit
          or waive your rights as a consumer under New Jersey law and the
          provisions in this Agreement are intended to be only as broad and
          inclusive as is permitted by the laws of the State of New Jersey. In
          any event, we reserve all rights, defenses and permissible limitations
          under the law of your State of residence.
        </p>
        <br /> <h4>MINORS</h4>
        <p>
          At this Website, Company and its affiliates make no active effort to
          collect personal information from individuals under the age of
          eighteen (18). We require that Website users must be of legal age to
          enter into agreements (typically, at least eighteen (18) years of age
          or older).
        </p>
        <br /> <h4>NOT A SECURITY OFFER</h4>
        <p>
          The information contained on this Website is not an offer to sell or a
          solicitation to buy any security. No security is offered or will be
          sold in any jurisdiction in which such offer or solicitation, purchase
          or sale would be unlawful under the securities laws of such
          jurisdiction
        </p>
        <br /> <h4>SEVERABILITY</h4>
        <p>
          If any part of these Terms of Use is unlawful, void or unenforceable,
          that part will be deemed deleted and will not affect the validity and
          enforceability of any remaining provisions. The waiver of a breach of
          any provision of this Agreement by a party will not operate or be
          construed as such party’s waiver of any other or subsequent breach.
          These Terms of Use constitute the entire agreement between you and
          Company and its affiliates relating to this subject matter.
          Notwithstanding the foregoing, any additional terms and conditions on
          this Website will govern the items to which they pertain.
        </p>
        <br /> <h4>EMPLOYMENT OPPORTUNITIES</h4>
        <p>
          Company and its affiliates are an equal opportunity employer,
          dedicated to a policy of non-discrimination in employment on any basis
          including race, color, age, sex, religion, disability or national
          origin. Consistent with the American Disabilities Act, applicants may
          request accommodations needed to participate in the application
          process.
        </p>
        <br /> <h4>CONTACT US</h4>
        <p>
          For further information, or inquiries about these Terms of Use, please
          contact:
        </p>
        <p>SuretyBonds.com</p>
        <p>3514 Interstate 70 Dr. SE</p>
        <p>Columbia, MO 65201</p>
        <a
          href="mailto:customercare@suretybonds.com"
          target="_blank"
          rel="noreferrer"
          className="block"
        >
          customercare@suretybonds.com
        </a>
        <a href="tel:+18003084358">1 (800) 308-4358</a>
        <br />
        <br /> <h4>Legal Disclaimer and Notice of Copyright</h4>
        <p>Proprietary Rights</p>
        <p>© Copyright {year}, SuretyBonds.com</p>
        <br />
        <br />{' '}
        <h4>
          NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT{' '}
        </h4>
        <p>
          NOTE: THE FOLLOWING INFORMATION IS PROVIDED EXCLUSIVELY FOR NOTIFYING
          THE SERVICE PROVIDERS REFERENCED BELOW THAT YOUR COPYRIGHTED MATERIAL
          MAY HAVE BEEN INFRINGED. ALL OTHER INQUIRIES WILL NOT RECEIVE A
          RESPONSE THROUGH THIS PROCESS.
        </p>
        <p>
          Pursuant to Title 17, U.S. Code, Section 512(c)(2), written
          notification must be submitted to the following Designated Agent:
        </p>
        <p>Service Provider(s):</p>
        <p>
          Tokio Marine HCC <br /> 13403 Northwest Freeway <br /> Houston, TX
          77040
        </p>
        <p>
          Name of Agent Designated to Recieve Notification of Claimed
          Infringement:
        </p>
        <p>Alexander Ludlow</p>
        <br />
        <p>
          Full Address of Designated Agent to Which Notification Should be Sent:
        </p>
        <p>13403 Northwest Freeway, Houston, TX 77040</p>
        <br />
        <p>Telephone Number of Designated Agent: </p>
        <a href="tel:+17134621000" className="underline">
          (713) 462-1000
        </a>
        <br />
        <p>Facsimile Number of Designated Agent:</p>
        <a href="tel:+17137449648" className="underline">
          (713) 744-9648
        </a>
        <br />
        <p>Email Address of Designated Agent: </p>
        <a
          href="mailto:copyright@tmhcc.com"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          copyright@tmhcc.com
        </a>
        <br />
        <h4>To be effective, the Notification must include the following:</h4>
        <ol>
          <li>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of an exclusive right that is allegedly
            infringed;{' '}
          </li>
          <li>
            Identification of the copyrighted work claimed to have been
            infringed, or if multiple copyrighted works at a single online site
            are covered by a single notification, a representative list of such
            works at that site;{' '}
          </li>
          <li>
            Identification of the material that is claimed to be infringing or
            to be the subject of infringing activity and that is to be removed
            or access to which is to be disabled, and information reasonably
            sufficient to permit the service provider to locate the material;{' '}
          </li>
          <li>
            Information reasonably sufficient to permit the service provider to
            contact the Complaining Party, such as an address, telephone number,
            and if available, an electronic mail address at which the
            complaining party may be contacted;{' '}
          </li>
          <li>
            A statement that the Complaining Party has a good faith belief that
            use of the material in the manner complained of is not authorized by
            the copyright owner, its agent, or the law; and{' '}
          </li>
          <li>
            A statement that the information in the notification is accurate,
            and under penalty of perjury, that the Complaining Party is
            authorized to act on behalf of the owner of an exclusive right that
            is allegedly infringed.{' '}
          </li>
        </ol>{' '}
        <br />
      </div>
    </div>
  );
}
